var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"dense":""}},[_c('v-toolbar-items',_vm._l((_vm.tabs),function(tab,index){return _c('Link',{key:index,attrs:{"as":"v-btn","href":_vm.$route('central.popularities.' + tab.value),"input-value":_vm.$route().current(
							'central.popularities.' + tab.value
						),"text":""}},[_vm._v("\n\t\t\t\t\t"+_vm._s(tab.text)+"\n\t\t\t\t")])}),1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }